import React from 'react'
import {
    Fab,
    Link,
} from '@material-ui/core'
import PhoneEnabledOutlinedIcon from '@material-ui/icons/PhoneEnabledOutlined'
import MailOutlinedIcon from '@material-ui/icons/MailOutlined'
import { makeStyles } from '@material-ui/styles'
import { createMailToLink } from '../../utils/MailToLink'
import { useTranslation } from 'react-i18next'

const useStyles = makeStyles(theme => ({
    icon: {
        marginRight: 10,
    },
    link: {
        color: '#FFF',
    },
    fab: {
        position: 'fixed',
        bottom: '2rem',
        right: '2rem',
        padding: 30,
    },
    column: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
    },
    row: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'row',
    }
}))

function AppFeedbackButton() {
    const classes = useStyles()
    const { t } = useTranslation()

    createMailToLink({
        to: "servicedesk@fednot.be",
        subject: "Clausule-module - Feedback",
    })

    return (
        <Fab
            variant="extended"
            color="primary"
            className={classes.fab}
        >
            <div className={classes.column}>
                <div className={classes.row}>
                    <PhoneEnabledOutlinedIcon className={classes.icon} />
                    <Link href="tel:025050888" target="_blank" rel="noopener" className={classes.link}>
                        02/505 08 88
                    </Link>
                </div>
                <div className={classes.row}>
                    <MailOutlinedIcon className={classes.icon} />
                    <Link target="_blank" rel="" className={classes.link} href={
                        createMailToLink({
                            to: "servicedesk@fednot.be",
                            subject: t('email.generalFeedback.subject'),
                        })
                    }>
                        servicedesk@fednot.be
                    </Link>
                </div>
            </div>
        </Fab>
    )
}

export default AppFeedbackButton
